export enum VehiculeStatus {
	available = 'Disponible',
	unavailable = 'Indisponible',
	used = "En cours d'utilisation"
}
